import { Stack, Box, Typography, Divider, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import { fDateTime } from "../../utils/formatTime";
import { int2ip } from "../../utils/formatIpAddress";

const HostPortElement = ({ port, el }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box
            p={0.5}
        >
            <Stack
                p={0.5}
                sx={{
                    flex: "1",
                    minWidth: "320px",
                    backgroundColor:
                        theme.palette.mode === "light"
                            ? "#F8FAFF"
                            : theme.palette.background,
                    boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.25)",
                }}
                
            >
                <Typography sx={{ color: colors.greenAccent[600] }}>Interface {port}</Typography>
                <Divider/>
                <Stack
                    direction="row"
                    spacing={{ xs: 1, sm: 2 }}
                    useFlexGap
                    sx={{ flexWrap: 'wrap' }}
                >
                {el.map((fdb) => {
                    return  fdb.arp.map((arp) => {
                                if (arp.billing_users) {
                                    return  arp.billing_users.map((billing_user) => {
                                                return (
                                                    <Stack>
                                                        <Stack p={1}>
                                                                <Typography variant="h5" sx={{ color: colors.greenAccent[600] }}>{billing_user.login}</Typography>
                                                        </Stack>
                                                        <Stack
                                                            direction="row"
                                                        >
                                                            <Stack p={1}>
                                                                <Typography variant="subtitle2">{int2ip(arp.ip)}</Typography>
                                                                <Typography variant="caption">{fDateTime(arp.timestamp)}</Typography>
                                                            </Stack>
                                                            <Stack p={1}>
                                                                <Typography variant="subtitle2">{fdb.mac}</Typography>
                                                                <Typography variant="caption">{fDateTime(fdb.timestamp)}</Typography>
                                                            </Stack>
                                                        </Stack>
                                                    </Stack>
                                                );
                                            })
                                }
                            })
                })}
                </Stack>
                
            </Stack>
        </Box>
        
    );
};

export default HostPortElement;